import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

export interface UserLookupResult {
  code: 'found' | 'not_found';
  slug?: string;
  name?: string;
  email?: string;
  loginIntegrationEnabled?: boolean;
  loginProvider?: string;
  clientId?: string;
  tenantId?: string;
  openIdConfigurationEndpoint?: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserLookupService {
  constructor(private readonly apollo: Apollo) { }

  async lookupUserByEmail(email: string): Promise<UserLookupResult> {
    return this.apollo.query({
      query: gql`
        query userLookup($email: String!){
          userLookup(email: $email) {
            code
            email
            name
            loginIntegrationEnabled
            loginProvider
            slug
            clientId
            tenantId
            openIdConfigurationEndpoint
          }
        }
      `,
      variables: { email }
    })
      .toPromise()
      .then((result) => result.data['userLookup']);
  }
}
